export default __webpack_public_path__ + "static/DEIPage-pattern-large-whale-tail-f280dd45d98350b1286ee9a47ef203a5.png";